/**
 * errorCollector.ts
 * Буфер выхватывания логов ошибок и глобальных JS-ошибок браузера.
 */

export interface CapturedError {
  timestamp: string;
  type: 'console.error' | 'window.onerror' | 'unhandledrejection';
  message: string;
  stack?: string;
}

const MAX_ERRORS = 15;
const capturedErrors: CapturedError[] = [];

// Перехват console.error
const originalConsoleError = console.error;
console.error = (...args: any[]) => {
  try {
    const message = args
      .map(arg => (typeof arg === 'object' ? JSON.stringify(arg, null, 2) : String(arg)))
      .join(' ');
    
    // Игнорируем специфичные ворнинги расширений браузера
    if (!message.includes('chrome-extension://') && !message.includes('Download the React DevTools')) {
      capturedErrors.push({
        timestamp: new Date().toLocaleTimeString('ru-RU'),
        type: 'console.error',
        message: message.substring(0, 1000),
      });

      if (capturedErrors.length > MAX_ERRORS) {
        capturedErrors.shift();
      }
    }
  } catch {}

  originalConsoleError.apply(console, args);
};

// Перехват unhandled error
window.addEventListener('error', (event) => {
  try {
    capturedErrors.push({
      timestamp: new Date().toLocaleTimeString('ru-RU'),
      type: 'window.onerror',
      message: event.message || 'Script error',
      stack: event.error?.stack?.substring(0, 1000),
    });
    if (capturedErrors.length > MAX_ERRORS) {
      capturedErrors.shift();
    }
  } catch {}
});

// Перехват unhandled promise rejection
window.addEventListener('unhandledrejection', (event) => {
  try {
    const reason = event.reason;
    const message = typeof reason === 'object' ? (reason?.message || JSON.stringify(reason)) : String(reason);
    capturedErrors.push({
      timestamp: new Date().toLocaleTimeString('ru-RU'),
      type: 'unhandledrejection',
      message: message.substring(0, 1000),
      stack: reason?.stack?.substring(0, 1000),
    });
    if (capturedErrors.length > MAX_ERRORS) {
      capturedErrors.shift();
    }
  } catch {}
});

export function getCapturedErrors(): CapturedError[] {
  return [...capturedErrors];
}

export function clearCapturedErrors(): void {
  capturedErrors.length = 0;
}
